import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              {" "}
              <p>
                I am <span className="purple">Annapurna Gothe,</span> a computer
                science student with a focus on front-end development,
                blockchain innovations, and exploring Web3
              </p>
              <p>
                I have{" "}
                <span className="purple">
                  won multiple hackathons, participated in many web2/web3
                  competitions,
                </span>{" "}
                and solved over 50 challenges on{" "}
                <span className="purple">Leetcode / HackerRank.</span>{" "}
              </p>
              <p>
                {" "}
                Notably, I reached the{" "}
                <span className="purple">
                  Grand Finale of the Smart India Hackathon 2023
                </span>{" "}
                and made many projects on{" "}
                <span className="purple">Blockchain , Web3, Networking,</span>{" "}
                etc...
              </p>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img
                src="https://github.com/Annapurna138/Annapurna138/assets/101049112/5faddf09-d596-4121-b6ce-7eec806a5dbc"
                className="img-fluid"
                alt="avatar"
              />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
